import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppPattern } from 'src/app/services/app-pattern';
import { MasterDataService } from 'src/app/services/master-data.service';
import { UserDetailsCommon } from '../user-details.common';
import * as moment from 'moment';
import { HumanResourceService, UserProfileService } from 'src/app/services/human-resource.service';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.css'],
})
export class PersonalDetailsComponent implements OnInit {
  appPattern = new AppPattern();
  user: any;
  employeeForm;
  employeeFormErrors = UserDetailsCommon.personalDetailsFormError;
  employeeFormValidationMessages =
    UserDetailsCommon.personalDetailsValidationMessages;
  employeeFormSubmitted = false;
  certificationList: any;

  stateList: any;
  permanentCityList: any;
  permanentPostcodeList: any;
  showPermanentCity = false;
  showPermanentPostCode = false;
  modalStatus = 'edit';
  userPhoto: any;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService:CommonMessageService,
    private userProfileService:UserProfileService
  ) {}

  ngOnInit(): void {
    this.initModalForm();
    this.loadUserDetails();
  }

  loadUserDetails() {
    this.masterDataService.getUserProfile().subscribe((res) => {
      console.log('user resp', res);
      this.user = res;
      console.log('this.user', this.user);
      this.loadCertificationList();
    });
  }

  loadCertificationList() {
    this.masterDataService.getCertificationList().subscribe((res) => {
      console.log(res);
      this.certificationList = res;
      this.loadState();
    });
  }

  loadState() {
    this.masterDataService.getStates().subscribe((res) => {
      console.log(res);
      this.stateList = res;
      this.loadUserPhoto();
    });
  }

  loadUserPhoto() {
    this.humanResourceService.getProfilePhoto().subscribe((resp) => {
      console.log(resp);
      this.userPhoto = resp;
    });
  }

  compareItems(i1, i2) {
    return i1 && i2 && i1.id === i2.id;
  }

  openModal(content) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };

    // this.resetModalForm();

    this.modalService.open(content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  initModalForm() {
    this.employeeForm = this.fb.group({
      //
      dateOfBirth: ['', [Validators.required]],
      bloodGroup: ['', [Validators.required]],
      panNumber: [
        '',
        [Validators.required, Validators.pattern(this.appPattern.PAN_PATTERN)],
      ],
      aadharNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(this.appPattern.AADHAR_PATTERN),
        ],
      ],
      qualification: ['', [Validators.required]],
      certificationType: ['', [Validators.required]],
      description: ['', []],
      //
      personalEmail: ['', [Validators.required]],
      officalMobileNumber: ['', [Validators.required]],
      contactMobileNumber: ['', [Validators.required]],
      //
      emergencyContactNumber1: ['', [Validators.required]],
      emergencyContactName1: ['', [Validators.required]],
      emergencyContactRelation1: ['', [Validators.required]],
      //
      permanentAddress: this.fb.group({
        address: ['', [Validators.required]],
        city: [null, [Validators.required]],
        state: [null, [Validators.required]],
        postalCode: [null, [Validators.required]],
        country: ['', [Validators.required]],
        streetName: ['', [Validators.required]],
        type: 'permanent',
      }),
    });
  }

  showDescription = false;
  checkSelection() {
    console.log(this.employeeForm.value);
    var index = this.employeeForm.value.certificationType.findIndex(
      (item) => item.id === 6
    );
    if (index >= 0) {
      this.showDescription = true;
      this.employeeForm.get('description').setValidators(Validators.required);
      this.employeeForm.controls.certificationType.patchValue([
        { id: 6, name: 'Others' },
      ]);
    } else {
      this.showDescription = false;
      this.employeeForm.get('description').clearValidators();
    }
    this.employeeForm.get('description').updateValueAndValidity();
  }
  //---------------------------------------
  loadPermanantCities(value) {
    this.masterDataService.getCities(value.id).subscribe((res) => {
      console.log(res);
      this.permanentCityList = res;
    });
  }

  loadPermanantPostcode(value) {
    this.masterDataService.getPostcode(value.id).subscribe((res) => {
      console.log(res);
      this.permanentPostcodeList = res;
    });
  }

  enablePermanentCity() {
    var stateId = this.employeeForm.value.permanentAddress.state.id;
    console.log(stateId);
    this.employeeForm.controls['permanentAddress'].patchValue({ city: null });
    this.masterDataService.getCities(stateId).subscribe((res) => {
      console.log(res);
      this.permanentCityList = res;
      this.showPermanentCity = true;
    });
  }

  enablePermanentPostCode() {
    var cityId = this.employeeForm.value.permanentAddress.city.id;
    this.employeeForm.controls['permanentAddress'].patchValue({
      postalCode: null,
    });
    this.masterDataService.getPostcode(cityId).subscribe((res) => {
      console.log(res);
      this.permanentPostcodeList = res;
      this.showPermanentPostCode = true;
    });
  }

  onEditClick(content) {
    this.setJsonToModal(content, this.user);
  }

  setJsonToModal(content, modalObj) {
    var dob1 = new Date(modalObj.userPersonalDetails.dateOfBirth);
    var dob2 = moment(dob1, 'YYYY/MM/DD');
    var dob = {
      year: parseInt(dob2.format('YYYY')),
      month: parseInt(dob2.format('M')),
      day: parseInt(dob2.format('D')),
    };

    var userCertifications = [];
    var description = '';
    modalObj.userPersonalDetails.userCertifications.forEach(
      (certification, certificationKey) => {
        if (certification.certificationType.id == 6) {
          description = certification.description;
          userCertifications.push();
        }
        userCertifications.push(certification.certificationType);
      }
    );

    this.employeeForm.patchValue({
      dateOfBirth: dob,
      bloodGroup: modalObj.userPersonalDetails.bloodGroup,
      panNumber: modalObj.userPersonalDetails.panNumber,
      aadharNumber: modalObj.userPersonalDetails.aadharNumber,
      qualification: modalObj.userPersonalDetails.qualification,
      certificationType: userCertifications,
      //
      personalEmail: modalObj.userPersonalDetails.personalEmail,
      officalMobileNumber: modalObj.userPersonalDetails.officalMobileNumber,
      contactMobileNumber: modalObj.userPersonalDetails.contactMobileNumber,
      //
      emergencyContactNumber1:
        modalObj.userPersonalDetails.emergencyContactNumber1,
      emergencyContactName1: modalObj.userPersonalDetails.emergencyContactName1,
      emergencyContactRelation1:
        modalObj.userPersonalDetails.emergencyContactRelation1,
    });

    var pIndex = modalObj.addresses.findIndex(
      (item) => item.type === 'permanent'
    );
    var pAddress;
    if (pIndex >= 0) {
      pAddress = modalObj.addresses[pIndex];
      var permanentStateIndex = -1;
      if (modalObj.addresses[pIndex].state) {
        permanentStateIndex = this.stateList.findIndex(
          (item) => item.id == modalObj.addresses[pIndex].state.id
        );
      }
      console.log(this.stateList[permanentStateIndex]);
      this.employeeForm.controls['permanentAddress'].patchValue({
        address: modalObj.addresses[pIndex].address,
        city: modalObj.addresses[pIndex].city,
        state: this.stateList[permanentStateIndex],
        postalCode: modalObj.addresses[pIndex].postalCode,
        country: modalObj.addresses[pIndex].country,
        streetName: modalObj.addresses[pIndex].streetName,
        type: 'permanent',
      });
    }

    if (pAddress.city == null) {
      this.showPermanentCity = true;
    }
    if (pAddress.postalCode == null) {
      this.showPermanentPostCode = true;
    }
    this.openModal(content);
  }

  onUpdateClick() {
    console.log('onUpdateClick');
    console.log(this.employeeForm);
    this.employeeFormSubmitted = true;
    this.logValidationErrors(this.employeeForm);
    if (this.employeeForm.valid) {
      var jsonData = this.getJsonFromModal();
      console.log(jsonData);
      this.humanResourceService
        .updateProfile(jsonData, this.user.userId)
        .subscribe((resp) => {
          console.log(resp);
          this.user = resp;
          this.closeModal();
          this.commonMessageService.updateMessage();
        });
    }
  }
  userDataExist: any;
  getJsonFromModal() {
    this.userDataExist = {};
    var userCertifications = [];
    var index = this.employeeForm.value.certificationType.findIndex(
      (item) => item.id === 6
    );
    if (index >= 0) {
      userCertifications = [
        {
          certificationType: { id: 6, name: 'Others' },
          description: this.employeeForm.value.description,
        },
      ];
    } else {
      this.employeeForm.value.certificationType.forEach(
        (certification, certificationKey) => {
          const cert = {
            certificationType: certification,
            description: '',
          };
          userCertifications.push(cert);
        }
      );
    }
    var dateOfBirth = new Date(
      this.employeeForm.value.dateOfBirth.year +
        '-' +
        this.employeeForm.value.dateOfBirth.month +
        '-' +
        this.employeeForm.value.dateOfBirth.day
    );

    this.userDataExist.id = this.user.id;
    this.userDataExist.type = this.user.type;
    this.userDataExist.addresses = [...this.user.addresses];
    if(this.user.designation==null){
    this.userDataExist.designation=null;
    }else{
      this.userDataExist.designation = { ...this.user.designation };
    }

    this.userDataExist.droles = [...this.user.droles];
    this.userDataExist.email = this.user.email;
    this.userDataExist.firstName = this.user.firstName;
    this.userDataExist.lastName = this.user.lastName;
    this.userDataExist.middleName = this.user.middleName;
    this.userDataExist.password = this.user.password;
    this.userDataExist.userCtcDetails = [...this.user.userCtcDetails];
    this.userDataExist.userOfficialDetails = {
      ...this.user.userOfficialDetails,
    };
    this.userDataExist.userPersonalDetails = {
      ...this.user.userPersonalDetails,
    };

    this.userDataExist.userPersonalDetails.dateOfBirth = moment(
      dateOfBirth
    ).format('YYYY-MM-DD');
    (this.userDataExist.userPersonalDetails.bloodGroup = this.employeeForm.value.bloodGroup),
      (this.userDataExist.userPersonalDetails.panNumber = this.employeeForm.value.panNumber),
      (this.userDataExist.userPersonalDetails.aadharNumber = this.employeeForm.value.aadharNumber),
      (this.userDataExist.userPersonalDetails.qualification = this.employeeForm.value.qualification),
      (this.userDataExist.userPersonalDetails.userCertifications = userCertifications),
      //
      (this.userDataExist.userPersonalDetails.personalEmail = this.employeeForm.value.personalEmail),
      (this.userDataExist.userPersonalDetails.officalMobileNumber = this.employeeForm.value.officalMobileNumber),
      (this.userDataExist.userPersonalDetails.contactMobileNumber = this.employeeForm.value.contactMobileNumber),
      //
      (this.userDataExist.userPersonalDetails.emergencyContactNumber1 = this.employeeForm.value.emergencyContactNumber1),
      (this.userDataExist.userPersonalDetails.emergencyContactName1 = this.employeeForm.value.emergencyContactName1),
      (this.userDataExist.userPersonalDetails.emergencyContactRelation1 = this.employeeForm.value.emergencyContactRelation1);
    this.userDataExist.addresses[0] = this.employeeForm.value.permanentAddress;

    return JSON.stringify(this.userDataExist);
  }

  ///---------------------------------------------------------
  @ViewChild('userProfileModalContent') private userProfileModalContent;
  openUserProfileModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };

    this.modalService
      .open(this.userProfileModalContent, ngbModalOptions)
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed`;
        }
      );
  }

  selectedUserForPhotoUpload;
  onUploadUserProfileClick(formObj) {
    this.selectedUserForPhotoUpload = formObj;
    console.log(this.selectedUserForPhotoUpload);
    this.openUserProfileModal();
  }
  fileList: FileList;
  formData: FormData;
  isFileValid = false;
  fileChange(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      let file: File = this.fileList[0];
      this.formData = new FormData();
      this.formData.append('files', file, file.name);
      if (
        file.type == 'image/png' ||
        file.type == 'image/jpg' ||
        file.type == 'image/jpeg'
      ) {
        this.isFileValid = true;
      } else {
        this.isFileValid = false;
        this.commonMessageService.swalAlertWithoutIcon('','Please select valid file format (.pn, .jpg, .jpeg)');
      }
      //  this.formData.append('file', file);
    }
  }

  onUploadClick() {
    if (this.isFileValid) {
      this.humanResourceService
        .uploadUserDocumentList(
          this.formData,this.selectedUserForPhotoUpload.userId,0,'Passport Photo')
        .subscribe(
          (resp) => {
            this.userProfileService.sendProfile();

            console.log(resp);
            this.userPhoto.url = resp.documentUrl;
            this.closeModal();
            this.commonMessageService.swalAlertWithIcon('','Uploded Successfully!','success');
          },
          (error) => {
            // console.log(error);
          }
        );
    }
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log(
          'Key = ' +
            key +
            ' && Value = ' +
            abstractControl.value +
            ' && Valid = ' +
            abstractControl.valid
        );
        // Clear the existing validation errors
        this.employeeFormErrors[key] = '';
        if (
          abstractControl &&
          !abstractControl.valid &&
          this.employeeFormSubmitted
        ) {
          // Get all the validation messages of the form control that has failed the validation
          const messages = this.employeeFormValidationMessages[key];
          console.log(messages);
          // Find which validation has failed. For example required, minlength or maxlength.
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey);
            if (errorKey) {
              this.employeeFormErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
}
